import styled, { css } from "styled-components";
import { ReactComponent as Home } from "../../../../assets/icons/ac.svg";
import { ReactComponent as Favorite } from "../../../../assets/icons/ac.svg";
export const Container = styled.div`
  width: 470px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: var(--default-text-color);
`;

const Items = css`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: ${({ main }) => (main ? "column" : "row")};
  ${({ item }) => item && Items};
`;
export const Titles = styled.div`
  font-weight: normal;
  font-size: var(--font-size-secondary);
  line-height: 18px;
  color: var(--icon-hover-color);
  a {
    color: var(--common-blue-color);
  }
  margin-left: 15px;
`;

export const Icon = styled.div``;

Icon.Home = styled(Home)`
  width: 40px;
  height: 40px;
  padding: 12px;
  border-radius: 30px;
  background: var(--light-bg-color);
  & path {
    fill: var(--icon-hover-color);
  }
  :hover {
    & path {
      fill: var(--common-blue-color);
    }
  }
  cursor: pointer;
  :active {
    transform: scale(1.1);
  }
`;
Icon.Favorite = styled(Favorite)`
  width: 40px;
  height: 40px;
  padding: 12px;
  border-radius: 30px;
  background: var(--light-bg-color);
  & path {
    fill: var(--icon-hover-color);
  }
  :hover {
    & path {
      fill: var(--common-blue-color);
    }
  }
  cursor: pointer;
  :active {
    transform: scale(1.1);
  }
`;
